import { AcademyIcon as Academy } from './AcademyIcon'
import { AccordionArrowIcon as AccordionArrow } from './AccordionArrowIcon'
import { AddIcon as Add } from './AddIcon'
import { AlertIcon as Alert } from './AlertIcon'
import { AllIcon as All } from './AllIcon'
import { AndroidLogoIcon as AndroidLogo } from './AndroidLogoIcon'
import { AppleLogoIcon as AppleLogo } from './AppleLogoIcon'
import { ArrowDropDownIcon as ArrowDropDown } from './ArrowDropDownIcon'
import { ArrowIcon as Arrow } from './ArrowIcon'
import { ArrowLeftGoIcon as ArrowLeftGo } from './ArrowLeftIcon'
import { ArrowRightGoIcon as ArrowRightGo } from './ArrowRightGoIcon'
import { ArrowUpIcon as ArrowUp } from './ArrowUpIcon'
import { AttachmentIcon as Attachment } from './AttachmentIcon'
import { AttentionIcon as Attention } from './AttentionIcon'
import { AwaitingIcon as Awaiting } from './AwaitingIcon'
import { BackIcon as Back } from './BackIcon'
import { BellIcon as Bell } from './BellIcon'
import { BookmarkIcon as Bookmark } from './BookmarkIcon'
import { BookOpenIcon as BookOpen } from './BookOpenIcon'
import { CalendarAttentionIcon as CalendarAttention } from './CalendarAttentionIcon'
import { CalendarHourIcon as CalendarHour } from './CalendarHourIcon'
import { CalendarIcon as Calendar } from './CalendarIcon'
import { CalendarPeriodIcon as CalendarPeriod } from './CalendarPeriod'
import { CalendarPlusIcon as CalendarPlus } from './CalendarPlusIcon'
import { CalendarWeekIcon as CalendarWeek } from './CalendarWeekIcon'
import { CameraIcon as Camera } from './CameraIcon'
import { CampaignIcon as Campaign } from './CampaignIcon'
import { CarIcon as Car } from './CarIcon'
import { CashIcon as Cash } from './CashIcon'
import { CategoryUserIcon as CategoryUser } from './CategoryUserIcon'
import { ChangeOrderIcon as ChangeOrder } from './ChangeOrderIcon'
import { ChargeIcon as Charge } from './ChargeIcon'
import { ChartIcon as Chart } from './ChartIcon'
import { ChatIcon as Chat } from './ChatIcon'
import { CheckConcludedIcon as CheckConcluded } from './CheckConcludedIcon'
import { CheckIcon as Check } from './CheckIcon'
import { ChevronIcon as Chevron } from './ChevronIcon'
import { ClipIcon as Clip } from './ClipIcon'
import { ClockIcon as Clock } from './ClockIcon'
import { CloseIcon as Close } from './CloseIcon'
import { CloseTabIcon as CloseTab } from './CloseTabIcon'
import { CommunicationIcon as Communication } from './CommunicationIcon'
import { ConcludedIcon as Concluded } from './ConcludedIcon'
import { ContentIcon as Content } from './ContentIcon'
import { CSVIcon as CSV } from './CSVIcon'
import { DashboardIcon as Dashboard } from './DashboardIcon'
import { DefaultIcon as Default } from './DefaultIcon'
import { DOCIcon as DOC } from './DOCIcon'
import { DOCXIcon as DOCX } from './DOCXIcon'
import { DollarIcon as Dollar } from './DollarIcon'
import { DownloadingIcon as Downloading } from './DownloadingIcon'
import { DropdownIcon as Dropdown } from './DropdownIcon'
import { EcosystemSIMIcon as EcosystemSIM } from './EcosystemSIMIcon'
import { EcosystemTurboIcon as EcosystemTurbo } from './EcosystemTurboIcon'
import { EcosystemWebmotorsIcon as EcosystemWebmotors } from './EcosystemWebmotorsIcon'
import { EditIcon as Edit } from './EditIcon'
import { EditTextIcon as EditText } from './EditTextIcon'
import { EmailIcon as Email } from './EmailIcon'
import { ExclamationIcon as Exclamation } from './ExclamationIcon'
import { EyeIcon as Eye } from './EyeIcon'
import { FileIcon as File } from './FileIcon'
import { FilterIcon as Filter } from './FilterIcon'
import { FlameSantanderIcon as FlameSantander } from './FlameSantanderIcon'
import { FormationIcon as Formation } from './FormationIcon'
import { GearIcon as Gear } from './GearIcon'
import { GiftIcon as Gift } from './GiftIcon'
import { GoOutIcon as GoOut } from './GoOutIcon'
import { GraphicIcon as Graphic } from './GraphicsIcon'
import { GroupIcon as Group } from './GroupIcon'
import { Heart } from './HeartIcon'
import { HomeIcon as Home } from './HomeIcon'
import { HourglassIcon as Hourglass } from './HourglassIcon'
import { InfoIcon as Info } from './InfoIcon'
import { IntegrationIcon as Integration } from './IntegrationIcon'
import { ItemValidatorIcon as Validator } from './ItemValidatorIcon'
import { JPGIcon as JPG } from './JPGIcon'
import { KanbanIcon as Kanban } from './KanbanIcon'
import { KeyIcon as Key } from './KeyIcon'
import { ListIcon as List } from './ListIcon'
import { LocationIcon as Location } from './LocationIcon'
import { LogoSantanderIcon as LogoSantander } from './LogoSantanderIcon'
import { LogoTurboIcon as LogoTurbo } from './LogoTurboIcon'
import { MacOsIcon as MacOs } from './MacOsIcon'
import { MailIcon as Mail } from './MailIcon'
import { Mobile } from './MobileIcon'
import { MoneyIcon as Money } from './MoneyIcon'
import { MoneyTurnoverIcon as MoneyTurnover } from './MoneyTurnoverIcon'
import { MoreFidelityIcon as MoreFidelity } from './MoreFidelityIcon'
import { MoreIcon as More } from './MoreIcon'
import { MP3Icon as MP3 } from './MP3Icon'
import { MP4Icon as MP4 } from './MP4Icon'
import { OrderByIcon as OrderBy } from './OrderByIcon'
import { OrganizationIcon as Organization } from './OrganizationIcon'
import { PadLockIcon as PadLock } from './PadLockIcon'
import { PDFIcon as PDF } from './PDFIcon'
import { PhoneIcon as Phone } from './PhoneIcon'
import { PlusIcon as Plus } from './PlusIcon'
import { PNGIcon as PNG } from './PNGIcon'
import { PortalMaisIcon as PortalMais } from './PortalMaisIcon'
import { PPTIcon as PPT } from './PPTIcon'
import { PreferencesIcon as Preferences } from './PreferencesIcon'
import { ProcessIcon as Process } from './ProcessIcon'
import { ProductIcon as Product } from './ProductIcon'
import { ProfileLevelBronze } from './ProfileLevelBronzeIcon'
import { ReadIcon as Read } from './ReadIcon'
import { RemoveAccountIcon as RemoveAccount } from './RemoveAccountIcon'
import { RoleIcon as Role } from './RoleIcon'
import { RotateIcon as Rotate } from './RotateIcon'
import { SantanderIcon as Santander } from './SantanderIcon'
import { SearchIcon as Search } from './SearchIcon'
import { ShareIcon as Share } from './ShareIcon'
import { ShieldIcon as Shield } from './ShieldIcon'
import { StarIcon as Star } from './StarIcon'
import { StoreIcon as Store } from './StoreIcon'
import { SuccessIcon as Success } from './SuccessIcon'
import { SuitcaseIcon as Suitcase } from './SuitcaseIcon'
import { SummaryStatusIcon as SummaryStatus } from './SummaryStatusIcon'
import { SupportIcon as Support } from './SupportIcon'
import { SurveyIcon as Survey } from './SurveyIcon'
import { TabIcon as Tab } from './TabIcon'
import { ThumbsDownIcon as ThumbsDown } from './ThumbsDownIcon'
import { ThumbsUpIcon as ThumbsUp } from './ThumbsUpIcon'
import { TrainingIcon as Training } from './TrainingIcon'
import { TrashGhostIcon as TrashGhost } from './TrashGhostIcon'
import { TrashIcon as Trash } from './TrashIcon'
import { UnionIcon as Union } from './UnionIcon'
import { UserIcon as User } from './UserIcon'
import { ViewAllIcon as ViewAll } from './ViewAllIcon'
import { WalletIcon as Wallet } from './WalletIcon'
import { WatchIcon as Watch } from './WatchIcon'
import { WebsiteIcon as Website } from './WebsiteIcon'
import { WindowsIcon as Windows } from './WindowsIcon'
import { WorldIcon as World } from './WorldIcon'
import { WorldPlanet } from './WorldPlanetIcon'
import { XLSIcon as XLS } from './XLSIcon'
import { XLSMIcon as XLSM } from './XLSMIcon'
import { XLSXIcon as XLSX } from './XLSXIcon'
import { ZendeskIcon as Zendesk } from './ZendeskIcon'
import { ZIPIcon as ZIP } from './ZIPIcon'

export default {
  Academy,
  All,
  AccordionArrow,
  Add,
  Alert,
  ArrowRightGo,
  AndroidLogo,
  ArrowLeftGo,
  Attachment,
  AppleLogo,
  ArrowDropDown,
  Arrow,
  ArrowUp,
  Awaiting,
  Attention,
  Bell,
  Bookmark,
  BookOpen,
  Graphic,
  Calendar,
  CalendarPlus,
  CalendarWeek,
  CalendarAttention,
  Camera,
  Campaign,
  Cash,
  CalendarPeriod,
  CategoryUser,
  ChangeOrder,
  Chat,
  Check,
  CheckConcluded,
  Clip,
  Chevron,
  Back,
  Clock,
  Close,
  Communication,
  Concluded,
  Content,
  CloseTab,
  Dashboard,
  Dollar,
  Home,
  Downloading,
  Dropdown,
  EcosystemSIM,
  EcosystemTurbo,
  CalendarHour,
  EcosystemWebmotors,
  Edit,
  EditText,
  Share,
  Email,
  Eye,
  File,
  Filter,
  FlameSantander,
  Gear,
  Gift,
  GoOut,
  Group,
  Heart,
  Hourglass,
  Info,
  Integration,
  Kanban,
  Key,
  List,
  Location,
  LogoTurbo,
  MacOs,
  Mail,
  Mobile,
  More,
  MoreFidelity,
  MP3,
  Money,
  OrderBy,
  Organization,
  PadLock,
  PDF,
  Phone,
  PNG,
  Preferences,
  Process,
  Product,
  ProfileLevelBronze,
  Plus,
  PortalMais,
  Read,
  RemoveAccount,
  Role,
  Rotate,
  Santander,
  Search,
  Shield,
  Star,
  Store,
  Success,
  Suitcase,
  ViewAll,
  Tab,
  Training,
  Trash,
  Union,
  User,
  Wallet,
  Watch,
  Website,
  Windows,
  World,
  WorldPlanet,
  ZIP,
  JPG,
  CSV,
  DOC,
  DOCX,
  PPT,
  XLS,
  XLSX,
  XLSM,
  MP4,
  SummaryStatus,
  Support,
  TrashGhost,
  ThumbsUp,
  ThumbsDown,
  Exclamation,
  Validator,
  Zendesk,
  LogoSantander,
  Survey,
  Formation,
  Charge,
  Car,
  Chart,
  MoneyTurnover,
  Default
}
